import type { Intersection } from 'utility-types'

import type { CybusDetailedMapping, CybusMapping } from '../../../../../../domain'

import { mapResourceName, type Resource } from '../../../../mappers'

export const mapBaseMapping = ({
    resourceId,
    runnerName,
    serviceId,
}: Resource<'Mapping'>): Omit<Intersection<CybusDetailedMapping, CybusMapping>, 'status'> => ({
    id: resourceId,
    name: mapResourceName(resourceId),
    service: serviceId,
    agent: runnerName,
})
